export enum FormActions {
  ADD = "ADD",
  EDIT = "EDIT",
  DELETE = "DELETE",
  DUPLICATE = "DUPLICATE",
}
